import React, { useEffect, useState } from 'react';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Box, Breadcrumbs, Link, Typography } from '@mui/material';
import { useManageFlows } from '../hooks/useManageFlows';
import { errorManageFlows } from '../../../redux/actions/flows';
import { DetailsFlow } from '../detailsFlow/DetailsFlow';
import { useNotification } from '../../../hooks/useNotification';
import { DialogConfirmAction } from '../../../components/dialogs/DialogConfirmAction';

export const LayoutFlows = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const [openDialogConfirmNotSaveChanges, setOpenDialogConfirmNotSaveChanges] = useState(false);
    const [sendNotification] = useNotification();
    const patharray = location.pathname.split('/').filter((x) => x);
    const pathnames = patharray.slice(1, patharray.length + 1);

    const [flowManager] = useManageFlows();
    const {
        isErrorFetch,
        messageErrorFetch,
        isChangeDataFlows
    } = flowManager;

    useEffect(() => {
        if (isErrorFetch) {
            sendNotification({ msg: messageErrorFetch, variant: 'error' });
            dispatch(errorManageFlows(false));
        }
    }, [isErrorFetch]);

    const validateChangesPending = () => {
        if (isChangeDataFlows)
            setOpenDialogConfirmNotSaveChanges(true);
        else
            handleConfirmeNotSaveChanges();
    }

    const handleConfirmeNotSaveChanges = () => navigate(-1);

    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ mb: 2, pt: 2, pl: 2, pr: 2 }}>
                <Breadcrumbs
                    aria-label="breadcrumb"
                    separator="›"
                    sx={{ mb: 2 }}
                >
                    <Link
                        underline="hover"
                        color="text.main"
                        sx={{ cursor: 'pointer' }}
                        onClick={() => validateChangesPending()}
                    >
                        <Typography
                            sx={{ fontWeight: pathnames.length === 0 && "bold" }}
                        >
                            Flows
                        </Typography>
                    </Link>
                    {
                        pathnames.length > 0 && pathnames.map((value, index) => {
                            const last = index === pathnames.length - 1;
                            const to = `/flows/${pathnames.slice(0, index + 1).join('/')}`;

                            return last ? (
                                <Typography
                                    sx={{ fontWeight: "bold" }}
                                    color="primary"
                                    key={to}
                                >
                                    {
                                        value.split("-").map(item => (
                                            item.charAt(0).toUpperCase() + item.slice(1)
                                        )).join(" ")
                                    }
                                </Typography>
                            ) : (
                                <Link
                                    key={to}
                                    underline="hover"
                                    color="text.main"
                                    sx={{ cursor: 'pointer' }}
                                    onClick={() => validateChangesPending(to)}
                                >
                                    {
                                        value.split("-").map(item => (
                                            item.charAt(0).toUpperCase() + item.slice(1)
                                        )).join(" ")
                                    }
                                </Link>
                            );
                        })
                    }
                </Breadcrumbs>

                <Routes>
                    <Route path={`/${pathnames}`} element={
                        <DetailsFlow
                            flowManager={flowManager}
                        />
                    } />
                </Routes>
            </Box>
            <DialogConfirmAction
                openDialogConfirm={openDialogConfirmNotSaveChanges}
                setOpenDialogConfirm={setOpenDialogConfirmNotSaveChanges}
                titleDialog={"Changes Pending To Save"}
                textConfirmAction={"You have unsaved changes, do you want to continue?"}
                textButtonConfirm={"Continue"}
                textButtonCancel={"Cancel"}
                handleConfirmAction={handleConfirmeNotSaveChanges}
            />
        </Box>
    )

}
